import React from 'react';

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="footer-content">
        <div>
          <h4>Fasilitas</h4>
          <p>Posyandu</p>
          <p>Masjid</p>
          <p>Area Olahraga</p>
        </div>
        <div>
          <h4>Wisata</h4>
          <p>Tanjung Gading</p>
          <p>Coming Soon</p>
          <p>Coming Soon</p>
        </div>
        <div>
          <h4>Social Media</h4>
          <p>Instagram</p>
        </div>
        <div>
          <h4>Get In Touch</h4>
          <p>(+62) 81346257168</p>
          <p>JLN PDAM KM12 RT 17</p>
          <p>KELURAHAN KARANG JOANG</p>
          <p>BALIKPAPAN UTARA</p>            
          <p>KALIMANTAN TIMUR</p>
        </div>
      </div>
    </footer>
  );
}